import { render, staticRenderFns } from "./PromotionFilter.vue?vue&type=template&id=69dc28c9"
import script from "./PromotionFilter.vue?vue&type=script&lang=js"
export * from "./PromotionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports